<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';

import CustomerCodeLookup from '@/components/lookups/CustomerCodeLookup.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  customerCode?: string;
}

export interface ValidData {
  customerCode: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});

const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.customerCode == null) return;

  emit('submit', event, {
    customerCode: formData.customerCode,
  });
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    :class="$style.jobEditChangeCustomerCodeDialogForm"
    validate-on="lazy"
    data-testid="jobEditChangeCustomerCodeDialogForm"
    @submit.prevent="handleSubmit"
  >
    <CustomerCodeLookup
      v-model="formData.customerCode"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
    />

    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<style lang="scss" module>
.jobEditChangeCustomerCodeDialogForm {
  display: contents;
}
</style>
